import {Pipe, PipeTransform} from '@angular/core';
import {FeatureToggleModel} from '@app/views/common/feature-toggles/featue-toggle.model';
import {FeatureTogglesService} from '@app/core/service/feature-toggles.service';

@Pipe({
    name: 'featureToggleStatus'
})
export class FeatureToggleStatusPipe implements PipeTransform {

    constructor(private featureTogglesService: FeatureTogglesService) {
    }

    transform(featureToggles: FeatureToggleModel[], keyName: string): boolean {
        return this.featureTogglesService.getFeatureToggleStatus(featureToggles, keyName);
    }
}
